// @ts-ignore
import React, {useCallback, useState} from "react";
import styles from "./Contract.module.scss";
import cx from "classnames"
import GenerateContract from "./GenerateContract.jsx";
import GenerateInvoice from "./GenerateInvoice.jsx";
import UploadAgreementDocuments from "./UploadAgreementDocuments";

const Contract = ({selectedFiles, setGeneratedInvoice,setGeneratedContract ,setSelectedFiles, request, emergency_org, emergency_city }) => {
  const [agreement, setAgreement] = useState(true);
  const [invoice, setInvoice] = useState(false);
  const [dopDocuments, setDopDocuments] = useState(false);

  // @ts-ignore
  return <div className={styles.containerTab}>
    <div className={styles.header}>
      <button
        type="button"
        id="perActTab"
        className={cx(styles.tab, { [styles.active]: agreement })}
        onClick={() => {
          setAgreement(true);
          setInvoice(false);
          setDopDocuments(false);
        }}
      >
                  <span className={styles.tabName} id="perActTitle">
                    Договор
                  </span>
      </button>
      {request.customer_type === 2 &&<button
        type="button"
        id="perActTab"
        className={cx(styles.tab, {[styles.active]: invoice})}
        onClick={() => {
          setAgreement(false);
          setInvoice(true);
          setDopDocuments(false);
        }}
      >
                  <span className={styles.tabName} id="perActTitle">
                    Инвойс
                  </span>
      </button>}
      <button
        type="button"
        id="perActTab"
        className={cx(styles.tab, { [styles.active]: dopDocuments })}
        onClick={() => {
          setAgreement(false);
          setInvoice(false);
          setDopDocuments(true);
        }}
      >
                  <span className={styles.tabName} id="perActTitle">
                    Доп. документы
                  </span>
      </button>
    </div>
    <div className={styles.containerContent}>
      <div className={cx(styles.content)}>
        <div className={cx(styles.tabContent, agreement && styles.active)}>
          {agreement && <div>
            <GenerateContract emergency_city={emergency_city} emergency_org={emergency_org} request={request} setGeneratedContract={setGeneratedContract}/>
          </div>}
        </div>
        <div className={cx(styles.tabContent, invoice && styles.active)}>
          {request.customer_type === 2 &&<GenerateInvoice request={request} setGeneratedInvoice={setGeneratedInvoice}/>}
        </div>
        <div className={cx(styles.tabContent, dopDocuments && styles.active)}>
          {dopDocuments && <UploadAgreementDocuments setSelectedFiles={setSelectedFiles} selectedFiles={selectedFiles}/>}
        </div>
      </div>
    </div>
  </div>
}

export default Contract
